import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function MasterPackSection() {
  const benefits = [{
    title: '¿Qué vas a recibir?',
    items: ['📚 4 libros digitales completos', '🎉 Más de 500 ideas', '🗝️ Juegos secretos', '💌 Frases con propósito', '🎁 Bonos exclusivos']
  }, {
    title: '¿Qué vas a lograr con tu familia?',
    items: ['💬 Charlar más y conectar de verdad', '😄 Crear recuerdos inolvidables', '💖 Fortalecer la confianza', '⏰ Aprovechar el tiempo juntos', '🌈 Recuperar la alegría']
  }, {
    title: '¿Qué vas a lograr vos?',
    items: ['✨ Salir de la rutina', '🧠 Entender más a tus hijos', '💞 Sentirte presente', '🎯 Ahorrar tiempo', '🌟 Ser el corazón de tu familia']
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-144">
      <div className="max-w-6xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-147">
            💞 ¿Por qué es único?
          </h2>
          <p className="text-xl text-gold-400 font-medium" data-id="element-148">
            El Pack 100 Citas te da todo lo que necesitás para reconectar con tu
            familia.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-149">
          {benefits.map((col, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-6 md:p-8 shadow-2xl" data-id="element-150">
              <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-navy-700" data-id="element-151">
                {col.title}
              </h3>
              <div className="space-y-4" data-id="element-152">
                {col.items.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-153">
                    <div className="w-2 h-2 rounded-full bg-gold-500 mt-2 flex-shrink-0" data-id="element-154" />
                    <span className="text-slate-200 text-sm md:text-base" data-id="element-155">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}